import { createContext, useContext } from 'react';
import { Device } from '@features/home/types';
import { PropertyManifestEntry } from '@features/home-manifest/types';
import { Sensor } from '@features/plan-manifest/types';

export interface ProvisioningContextType {
  devices: Device[];
  entries: PropertyManifestEntry[];
  onPairSensor: (data: [PropertyManifestEntry, Sensor] | null) => void;
  onUnpairSensor: (manifestEntry: PropertyManifestEntry, sensor: Sensor) => Promise<void>;
  onRemoveDevice: (manifestEntry: PropertyManifestEntry) => void;
  onAddDevice: (manifestEntry: PropertyManifestEntry) => void;
  onAddSmartstartDevice: (manifestEntry: PropertyManifestEntry) => void;
  onResetDevice: (manifestEntry: PropertyManifestEntry) => void;
  onManualUnlinkDevice: (manifestEntry: PropertyManifestEntry) => void;
  onManualLinkDevice: (manifestEntry: PropertyManifestEntry) => void;
}

export const ProvisioningContext = createContext<ProvisioningContextType | undefined>(undefined);

export function useProvisioning() {
  const ctx = useContext(ProvisioningContext);
  if (!ctx) throw new Error('useProvisioning must be used within a ProvisioningContext.Provider');
  return ctx;
} 